export default "/build/images/030-3-100x100.png?75d1bbde8fe47d711fa339224a690b16";